import React, {Suspense}  from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { Callback } from "../components/auth/callback";
import { Logout } from "../components/auth/logout";
import { LogoutCallback } from "../components/auth/logoutCallback";
import { PrivateRoute } from "./privateRoute";
import { Register } from "../components/auth/register";
import { SilentRenew } from "../components/auth/silentRenew";
//import { PublicPage } from "../components/publicPage";
//import { PrivatePage } from "../components/privatePage";
import DetalleInscripcion from '../app/modules/Public/Inscripciones/DetalleInscripcion';
import Landing from '../app/modules/Public/home/Landing';
import { Routes as RoutesApp } from "../app/Routes";
import {Layout} from "../_metronic/layout";
import {LayoutSplashScreen} from "../_metronic/layout";
import PreInscripcion from '../app/modules/Inscripciones/preInscripcion/PreInscripcionPage';
import EstadoInscripcion from '../app/modules/Inscripciones/estadoInscripcion/EstadoInscripcion';

const isAuthenticated = () => {
    const oidcStorage = JSON.parse(sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`))

    return (!!oidcStorage && !!oidcStorage.access_token)
};

export const Routes = (
    <Switch>
        <Route exact={true} path="/signin-oidc" component={Callback} />
        <Route exact={true} path="/logout" component={Logout} />
        <Route
            exact={true}
            path="/logout/callback"
            component={LogoutCallback}
        />
        <Route
            exact={true}
            path="/:lng(en|es|de|fr|pt|it)/register/:form?"
            component={Register}
        />
        <Route exact={true} path="/silentrenew" component={SilentRenew} />

        {!isAuthenticated() ? (
            <Route exact={true} path="/noticias" component={Landing} />
        ) : (
            <Redirect from="/noticias" exact={true} to="/" />
        )}

        <Route path="/consulta" component={DetalleInscripcion} />
        <Route exact={true} path="/noticias" component={Landing} />



        {!isAuthenticated() ? (
            <Redirect from="/" exact={true} to="/noticias" />
        ) : (
            // <PrivateRoute path="/" component={RoutesApp} />
            <Layout>
                <Suspense fallback={<LayoutSplashScreen/>}>
                    <Switch>
                        {
                            /* Redirect from root URL to /dashboard. */
                            <Redirect exact from="/" to="/inicio"/>
                        }
                        {/* 
                        <Route path="/google-material" component={GoogleMaterialPage}/>
                        <Route path="/react-bootstrap" component={ReactBootstrapPage}/> 
                        */}
                        <PrivateRoute path="/inicio" component={PreInscripcion}/>
                        <PrivateRoute path="/estado/:inscripcionNumero" component={EstadoInscripcion}/>
                        <Redirect to="error/error-v1"/>
                    </Switch>
                </Suspense>
            </Layout>
        )}

        <PrivateRoute path="/" component={RoutesApp} />

    </Switch>
       
);
